import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
    state: 
    {        
        alert : {
            message : "",
            type : "",
            show : false
        },
        origin : "",
        localization: "",
        integrationName: "",
        appCode: "",
        userSign: false,
        urlRedirect: "",
        labelLogin: "",
        show : false,
        login : {
            labelLogin : "",
            persist : true
        },
        inTranslation: true,
        active_BR: false,
        active_ES: false,
        active_US: false,
        urlLogo: "",
        orquestraBootstrapCDN: "",
        skinFile: "",
        globalJsCss: "",
        codSystem: 5,
        isSaml: false,
        samlIssuer: "",
        samlMetadata: ""
    },
    mutations : 
    {
        CHANGE_SAML: function (state, payload) {
            state.isSaml = payload;
        },
        CHANGE_SAML_ISSUER: function (state, payload) {
            state.samlIssuer = payload;
        },
        CHANGE_SAML_METADATA: function (state, payload) {
            state.samlMetadata = payload;
        },
        CHANGE_CODSYSTEM: function (state, payload) {
            state.codSystem = payload;
        },
        CHANGE_ORIGIN : function (state,payload){
            state.origin = payload;
        },
        CHANGE_LOCALIZATION: function (state, payload) {
            state.localization = payload;
        },
        CHANGE_INTEGRATION_NAME: function (state, payload) {
            state.integrationName = payload;
        },
        CHANGE_APP_CODE: function (state, payload) {
            state.appCode = payload;
        },
        CHANGE_USER_SIGN: function (state, payload) {
            state.userSign = payload;
        },
        CHANGE_URL_REDIRECT: function (state, payload) {
            state.urlRedirect = payload;
        },       
        CHANGE_LABEL_LOGIN: function (state, payload) {
            state.labelLogin = payload;
        },
        CHANGE_SHOW : function (state,payload){
            state.show = payload;
        }, 
        CHANGE_ALERT_MESSAGE : function (state,payload){
            state.alert.message = payload;
        }, 
        CHANGE_ALERT_TYPE : function (state,payload){
            state.alert.type = payload;
        },
        CHANGE_ALERT_SHOW : function (state,payload){
            state.alert.show = payload;
        },    
        CHANGE_LOGIN_PERSIST : function (state,payload){
            state.login.persist = payload;
        },
        CHANGE_IN_TRANSLATION: function (state, payload) {
            state.inTranslation = payload;
        },
        CHANGE_ACTIVE_BR: function (state, payload) {
            state.active_BR = payload;
        },
        CHANGE_ACTIVE_US: function (state, payload) {
            state.active_US = payload;
        },
        CHANGE_ACTIVE_ES: function (state, payload) {
            state.active_ES = payload;
        },
        CHANGE_ORQUESTRA_BOOTSTRAP_CDN: function (state, payload) {
            state.orquestraBootstrapCDN = payload;
        },
        CHANGE_LOGO_URL: function (state, payload) {
            state.urlLogo = payload;
        },
        SKIN_FILE: function (state, payload) {
            state.skinFile = payload;
        },
        GLOBAL_JS_CSS: function (state, payload) {
            state.globalJsCss = payload
        }
    }
})
